import { IFilter } from "@saleor/components/Filter";
import { commonMessages } from "@saleor/intl";
import { FilterOpts } from "@saleor/types";
import { createBooleanField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

  export enum CountryFilterKeys {
    enable = "enable"
  }

  export interface CountryListFilterOpts{
    enable:FilterOpts<boolean>
  }

  const messages = defineMessages({
    enable: {
      defaultMessage: "enable",
      description: "enable"
    }
  });
  
  export function createFilterStructure(
    intl: IntlShape,
    opts: CountryListFilterOpts
  ): IFilter<CountryFilterKeys> {
    return [
      {
        ...createBooleanField(
          CountryFilterKeys.enable,
          intl.formatMessage(messages.enable),
          opts.enable.value,
          {
            negative: intl.formatMessage(commonMessages.no),
            positive: intl.formatMessage(commonMessages.yes)
          }
        ),
        active: opts.enable.active
      }
    ];
  }
  